






























import { Vue, Component, Watch } from 'vue-property-decorator';
import SyDetail from '@/components/SyDetail/Index.vue';
import { Button } from 'vant';
Vue.use(Button);
@Component({
  components: {
    SyDetail,
  },
})
export default class Detail extends Vue {
  schools: any[] = [];
  result: any[] = [];
  keyword = '';
  timer: any = null;
  value = '请输入关键词';

  @Watch('keyword')
  onKeywordChange(newval: string, oldval: string) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.search();
    }, 1000);
    if (!newval) {
      this.result = [];
    }
  }
  mounted() {
    // console.log('hello world', data);
    this.schools = require('../assets/data.json').data.schools.map(
      (item: any) => {
        return {
          exactName: item,
        };
      },
    );
  }
  // 搜索
  search(exact: boolean = false) {
    if (!this.keyword) {
      return console.log('no keyword, and reject');
    }
    // emit some val
    console.log('emit your val');
    // this.$emit('input', this.keyword);
    this.result = [];
    console.log('用户输入关键词:', this.keyword);
    for (const schoolItem of this.schools) {
      if (exact) {
        // 精确匹配
        if (schoolItem.exactName.indexOf(this.keyword) !== -1) {
          console.log('精确匹配到搜索结果:', schoolItem.exactName);
          this.result.push(schoolItem.exactName);
        }
      } else {
        // 模糊匹配
        const reg = new RegExp(['', ...this.keyword, ''].join('.*'));
        if (reg.test(schoolItem.exactName)) {
          console.log('模糊匹配到搜索结果:', schoolItem.exactName);
          this.result.push(schoolItem.exactName);
        }
      }
    }
  }
}
